import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { ITopicRuleFormInput, ITopicRuleUpdateProps } from "./TopicRule.model";
import { topicRuleService } from "../../service/TopicRule/topicRule.service";
import TopicRuleForm from "./_topicForm";

const TopicRuleUpdate = ({
  data,
  setTopicRuleDialog,
  loadTopicRules,
}: ITopicRuleUpdateProps) => {
  const [id, setId] = useState<number | null>(null);

  const methods = useForm<ITopicRuleFormInput>({
    defaultValues: {
      topic: 0,
      year_of_experience: 0,
      high_no_of_question: 0,
      medium_no_of_question: 0,
      low_no_of_question: 0,
    },
  });

  useEffect(() => {
    if (data) {
      setId(data.id);
      methods.reset({
        topic: data.topic,
        year_of_experience: data.year_of_experience,
        high_no_of_question: data.high_no_of_question,
        medium_no_of_question: data.medium_no_of_question,
        low_no_of_question: data.low_no_of_question,
      });
    }
  }, [data]);

  const onSubmit = async (values: ITopicRuleFormInput) => {
    if (!id) return;

    const response = await topicRuleService.update(id, values);

    if (response.success) {
      loadTopicRules();
      setTopicRuleDialog(false);
    } else {
      Object.keys(response.errors || {}).forEach((field) => {
        methods.setError(field as any, {
          type: "manual",
          message: response.errors[field],
        });
      });
    }
  };

  return <TopicRuleForm methods={methods} onSubmit={onSubmit} isEdit={true} />;
};

export default TopicRuleUpdate;
